import {postWager} from '../api/postWager';

const setPostWager = (params) => {
    return async (dispatch, getState) => {
        try {
            await postWager(params);
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setPostWager
}